import { useMutation } from 'react-query';
import {PartnerApi} from "../../api/partner.api";
import {useDealsStore} from "../../store/deals.store";

export const useDeals = () => {
    const setDeals = useDealsStore((state) => state.setDeals);

    return useMutation(PartnerApi.deals, {
        onSuccess: (data) => {
            setDeals(data);
        },
        onError: (error) => {
            console.error('Login failed:', error);
        },
    });
};